(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4134],{

/***/ 5123:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de",
      function () {
        return __webpack_require__(9353);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_templates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1860);
/* harmony import */ var _components_templates_HomeTemplate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4344);
/* eslint-disable jsx-a11y/alt-text */ // import node_modules




// import components

// define page
var IndexPage = function(param) {
    var blogPosts = param.blogPosts, hrefLang = param.hrefLang, templateGenres = param.templateGenres;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_HomeTemplate__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        blogPosts: blogPosts,
        hrefLang: hrefLang,
        templateGenres: templateGenres
    });
};
IndexPage.propTypes = {
    blogPosts: prop_types__WEBPACK_IMPORTED_MODULE_4__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4__.shape({
        image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
        slug: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
        tags: prop_types__WEBPACK_IMPORTED_MODULE_4__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired).isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
    }).isRequired).isRequired,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    templateGenres: prop_types__WEBPACK_IMPORTED_MODULE_4__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4__.shape({
        slug: prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf(Object.values(_storylinerlabs_templates__WEBPACK_IMPORTED_MODULE_2__/* .TemplateGenreSlugEnum */ .V)).isRequired,
        coverImageSquared: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
        name: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
    }).isRequired).isRequired
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4348,2539,1860,675,6880,7926,2775,9774,2888,179], function() { return __webpack_exec__(5123); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);